import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useStyledTheme, useStickySafeNavigate } from '@equifinance/shared';
import Page from '../components/Page';
import DecisioningIcon from '../components/Icons/DecisioningIcon';

const DecisioningContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
  width:100%;
`;
const Rotate = styled.div`
  width:200px;
  height:200px;
  animation: rotation 4s infinite linear;
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
const DecisioningText = styled.p`${({ theme }) => `
  color:${theme.primary};
  font-size: ${theme.fontSize[11]};
  font-weight: ${theme.fontWeight.bold};
`}`;

function Decisioning() {
  const { id } = useParams() as {id: string};
  const theme = useStyledTheme();

  const navigate = useStickySafeNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate(`/approved/${id}`);
    }, 3000);
  }, []);

  return (
    <Page>
      <DecisioningContainer>
        <Rotate>
          <DecisioningIcon fill={theme.primary} />
        </Rotate>
        <DecisioningText>UNDER REVIEW...</DecisioningText>
      </DecisioningContainer>
    </Page>
  );
}

export default Decisioning;
